import React, { useEffect, useRef } from 'react';

import {
  Lottie,
} from '@uncinc/uncinc-react-kitchen-sink';

import lottieHamburger from '../../assets/lotties/hamburger-to-cross-to-hamburger/data.json';

import './style.scss';

const Hamburger = ({ onClick, menuOpen }) => {
  const lottieAnimation = useRef(null);

  useEffect(() => {
    if (lottieAnimation.current) {
      if (!menuOpen) {
        lottieAnimation.current.playSegments([60, 120], true);
      } else {
        lottieAnimation.current.playSegments([0, 60], true);
      }
    }
  }, [menuOpen]);

  return (
    <div
      key="123"
      className="Hamburger"
      onClick={onClick}
    >
      <Lottie
        key="1234"
        id="Hamburger__lottie--to-cross"
        className="Hamburger__lottie"
        data={lottieHamburger}
        onInit={(lottie) => lottieAnimation.current = lottie}
        loop={false}
        autoPlay={false}
        startPosition={0}
      />

    </div>
  );
};

export default React.memo(Hamburger);
